// window.addEventListener('wishlist-king:loaded', async (event) => {
//   console.log('wishlist-king:loaded', event);
//   const setInterval(() => {
//     if (window.wishlistPageInited) {
//       clearInterval(interval);
//       console.log('wishlist-king:loaded', event);
//       window.dispatchEvent(new CustomEvent('wishlist-king:initialized', { detail: { event.detail } }));
//     }
//   }, 1000);
// });

// window.pdp is set up inline in the head (snippets/custom-js-head.liquid): section scripts write to it while the page parses.

window.isOphSplitHandleSuffix = function (handle) {
  if (!handle) return false
  return handle.endsWith('-bl') || handle.endsWith('-pl')
}

/** Page product qualifies for ophthalmic split architecture (by type + handle; not all Blue Light types). */
window.isOphSplitPageProduct = function (pageHandle, pageType) {
  if (!pageHandle) return false
  const type = String(pageType || '').toLowerCase().trim()
  if (type === 'ophthalmic' || type === 'plain') return true
  if (pageHandle.endsWith('-pl')) return true
  if (pageHandle.endsWith('-bl')) return true
  return false
}

/** Runtime product should use ophthalmic PDP logic (configurator, variants, notify rules). */
window.isOphthalmicPdpProduct = function (product) {
  if (!product) return false
  if (window.pdp?.ophSplitArchitecture) return true
  return window.isOphSplitPageProduct(product.handle, product.product_type)
}

window.isOphOrRxPdpProduct = function (product) {
  if (!product) return false
  return product.product_type === 'Prescription' || window.isOphthalmicPdpProduct(product)
}

window.ensureOphSplitHandles = function (pageHandle, pageType, pageProductId) {
  if (!pageHandle) return false
  if (!window.isOphSplitPageProduct(pageHandle, pageType)) return false

  const blSuf = '-bl'
  const plSuf = '-pl'

  let role = 'main'
  let main = pageHandle
  let bl = pageHandle + blSuf
  let pl = pageHandle + plSuf

  if (pageHandle.endsWith(blSuf)) {
    role = 'bl'
    main = pageHandle.slice(0, -blSuf.length)
    bl = pageHandle
    pl = main + plSuf
  } else if (pageHandle.endsWith(plSuf)) {
    role = 'pl'
    main = pageHandle.slice(0, -plSuf.length)
    pl = pageHandle
    bl = main + blSuf
  }

  // Canonical main reload must not wipe landing -bl/-pl role (OOS siblings never
  // auto-select oph-type, so URL rewrite would otherwise jump to main).
  const prevRole = window.pdp.ophSplitArchitecture ? window.pdp.ophSplitRole : null
  if (role === 'main' && (prevRole === 'bl' || prevRole === 'pl')) {
    role = prevRole
  }

  window.pdp.ophSplitArchitecture = true
  window.pdp.ophSplitRole = role
  window.pdp.ophMainHandle = main
  window.pdp.ophSplitBlHandle = bl
  window.pdp.ophSplitPlHandle = pl
  if (pageProductId != null) window.pdp.ophPageProductId = pageProductId
  return true
}

/** Main handle without -bl / -pl suffix. */
window.getOphSplitBaseHandle = function (handle) {
  if (!handle) return handle
  if (handle.endsWith('-bl')) return handle.slice(0, -3)
  if (handle.endsWith('-pl')) return handle.slice(0, -3)
  return handle
}

/** Collection / nav: map oph-type filter to split sibling handle. */
window.getOphSplitHandleForOphType = function (handle, ophType) {
  const base = window.getOphSplitBaseHandle(handle)
  const type = String(ophType || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
  if (type === 'bluelight' || type === 'blue-light') return base + '-bl'
  if (type === 'plain') return base + '-pl'
  return base
}

/** Active Shopify product id for oph split (main / -bl / -pl) from current selection. */
window.getOphSplitActiveProductId = function () {
  if (!window.pdp?.ophSplitArchitecture) return null
  const sv = window.pdp.selectedVariant
  if (sv && sv.product_id) return sv.product_id
  const ophType = window.pdp.rx?.['oph-type']
  if (ophType === 'blue-light' && window.pdp.ophSplitBlProduct) return window.pdp.ophSplitBlProduct.id
  if (ophType === 'plain' && window.pdp.ophSplitPlProduct) return window.pdp.ophSplitPlProduct.id
  if (window.pdp.ophMainProduct) return window.pdp.ophMainProduct.id
  return window.pdp.currentProduct?.id || null
}

/** Main handle used for sliders / other-products when oph split is active. */
window.getOphSplitSliderHandle = function (handle) {
  if (!handle) return handle
  if (window.pdp?.ophSplitArchitecture && typeof window.getOphSplitBaseHandle === 'function') {
    return window.getOphSplitBaseHandle(handle)
  }
  return handle
}

/** Rewrite a product URL for collection oph-type filters (split siblings, no query param). */
window.rewriteShopifyProductUrlForOphType = function (href, ophType) {
  if (!href) return href
  const type = String(ophType || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
  const useSplitHandle = type === 'bluelight' || type === 'blue-light' || type === 'plain'
  try {
    const u = new URL(href, window.location.origin)
    if (!/\/products\/[^/]+/.test(u.pathname)) return href
    const match = u.pathname.match(/\/products\/([^/]+)/)
    if (!match) return href
    if (useSplitHandle) {
      u.pathname = u.pathname.replace(
        /\/products\/[^/]+/,
        '/products/' + window.getOphSplitHandleForOphType(match[1], type)
      )
      u.searchParams.delete('oph-type')
      return u.toString()
    }
    if (!u.searchParams.has('oph-type')) {
      u.searchParams.set('oph-type', type)
    }
    return u.toString()
  } catch (e) {
    return href
  }
}

/** Collection -> PDP: carry the chosen Z87 variant (lens type) across. */
window.rewriteShopifyProductUrlForSafetyLens = function (href, lens, variantId) {
  if (!href) return href
  var value = window.normalizeSafetyLensHandle(lens)
  if (!value && !variantId) return href
  try {
    var u = new URL(href, window.location.origin)
    if (!/\/products\/[^/]+/.test(u.pathname)) return href
    if (variantId) {
      u.searchParams.set('variant', String(variantId))
      u.searchParams.delete('safety-lens')
    } else if (value && !u.searchParams.has('variant')) {
      u.searchParams.set('safety-lens', value)
    }
    return u.toString()
  } catch (e) {
    return href
  }
}

;(function () {
  function shopifyCdnImageFilenameKey(url) {
    if (!url || typeof url !== 'string') return ''
    try {
      const pathOnly = url.split('?')[0]
      const file = pathOnly.split('/').pop() || ''
      return file.replace(/_(\d+)x(\d+)(?=\.(jpe?g|png|webp|gif)$)/i, '').toLowerCase()
    } catch (e) {
      return ''
    }
  }

  /**
   * Prefer the exact image `src` from collection JSON (`mainCollectionProducts` or a given product)
   * so `/products/` vs `/files/` matches what Shopify actually serves for that asset.
   */
  window.resolveShopifyCdnMediaFromCatalog = function (url, productOrHandle) {
    if (!url || typeof url !== 'string') return url
    const want = shopifyCdnImageFilenameKey(url)
    if (!want) return url

    var list = (typeof window !== 'undefined' && window.pdp && Array.isArray(window.pdp.mainCollectionProducts))
      ? window.pdp.mainCollectionProducts
      : null

    var product = null
    if (productOrHandle && typeof productOrHandle === 'object') {
      product = list && productOrHandle.handle
        ? list.find(function (p) { return p.handle === productOrHandle.handle })
        : null
      product = product || productOrHandle
    } else if (productOrHandle && typeof productOrHandle === 'string' && list) {
      product = list.find(function (p) { return p.handle === productOrHandle })
    }

    if (!product) return url

    function trySrc(src) {
      if (!src || typeof src !== 'string') return false
      if (shopifyCdnImageFilenameKey(src) === want) return true
      return false
    }

    var images = product.images
    if (Array.isArray(images)) {
      for (var i = 0; i < images.length; i++) {
        var im = images[i]
        var s = im && im.src
        if (trySrc(s)) return s
      }
    }
    var variants = product.variants
    if (Array.isArray(variants)) {
      for (var j = 0; j < variants.length; j++) {
        var fi = variants[j] && variants[j].featured_image && variants[j].featured_image.src
        if (trySrc(fi)) return fi
      }
    }
    return url
  }
})()

function compareArrays(array1, array2) {
  // Check if the arrays are of different lengths
  if (array1.length !== array2.length) {
      return false;
  }

  // Sort the arrays to simplify the comparison
  const sortedArray1 = array1.slice().sort();
  const sortedArray2 = array2.slice().sort();

  // Compare each element in the arrays
  for (let i = 0; i < sortedArray1.length; i++) {
      if (sortedArray1[i] !== sortedArray2[i]) {
          return false;
      }
  }

  return true;
}

/**
 * General function that runs a callback when any user interaction event is fired
 * @param {Function} callback - Function to execute when any monitored event occurs
 * @param {Object} options - Event listener options (default: { passive: true })
 */
function onUserInteraction(callback, options = { passive: true }) {
    // Events to monitor for user interaction
    const events = ['mouseover', 'keydown', 'touchmove', 'touchstart', 'wheel'];
    
    // Flag to ensure callback only runs once
    let hasTriggered = false;
    
    // Event handler function
    function eventHandler() {
        if (hasTriggered) return;
        
        hasTriggered = true;
        
        // Remove all event listeners
        events.forEach(event => {
            window.removeEventListener(event, eventHandler, options);
        });
        
        // Execute the callback
        callback();
    }
    
    // Add event listeners for all monitored events
    events.forEach(event => {
        window.addEventListener(event, eventHandler, options);
    });
    
    // Return cleanup function
    return function cleanup() {
        events.forEach(event => {
            window.removeEventListener(event, eventHandler, options);
        });
    };
}

// Example usage:
// onUserInteraction(() => {
//     console.log('User has interacted with the page!');
//     // Your code here
// });


const sunglassFrameColorSliderSelectMain = () => {
    const sliderWrap = document.querySelector('.multiple-items')
    if (!sliderWrap) return false
    const slider = new Flickity(sliderWrap)
    const active = document.querySelector('.multiple-items .slide-wrapper.active')
    if (active) {
        const id = active.getAttribute('data-flickity-slider-id')
        slider.selectCell(id ? +id : 0)
    }
    return true
}

const getTrackingUrlPatch = (url) => {
  let _url = url
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const paramsObj = {};
  urlParams.forEach((value, key) => {
    paramsObj[key] = value;
  });

  if (!_url.includes('https://neveneyewear.com')) {
    if (_url[0] === '/') _url = 'https://neveneyewear.com' + _url
    else _url = 'https://neveneyewear.com/' + _url
  }

  const linkUrl = new URL(_url);
  const urlWithoutParams = linkUrl.href;
  const linkWithoutParams = new URL(urlWithoutParams);
  const linkWithoutParamsSearch = new URLSearchParams(_url);
  const linkParams = new URLSearchParams(linkUrl.search);

  // for (const [key, value] of linkWithoutParamsSearch.entries()) {
  //   if (['_ab', '_fd', '_sc', 'variant', 'development', 'qty', 'edit', 'lens', 'upgrades', 'type', 'q', 'token', 'return_url'].includes(key)) {
  //     linkParams.append(key, value)
  //   }
  // }

  // for (const [key, value] of linkWithoutParamsSearch.entries()) {
  //   if (!linkParams.has(key)) {
  //     linkParams.append(key, value)
  //   }
  // }

  for (const [key, value] of urlParams.entries()) {
    if (!linkParams.has(key) && !['_ab', '_fd', '_sc', 'variant', 'development', 'qty', 'edit', 'lens', 'upgrades', 'type', 'q', 'token', 'return_url', 'page', 'oph-type', 'lens-color', 'fav-variant-id', 'tab', 'view'].includes(key)) {
      linkParams.append(key, value);
    }
  }

  linkUrl.search = linkParams.toString();

  return linkUrl.toString()
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('body').addEventListener('click', function(evt) {
        // Do some check on target
        if ( evt.target.matches('button.fs-shopify-add-cart.fs-shopify-add-cart-container') ) {
            setTimeout(() => {
                update_cart_content()
                update_header_icon()
            }, 1000);
        }
    }, true); // Use Capturing
})

const appDimension = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  doc.style.setProperty('--app-width', `${window.innerWidth}px`);
}

const EVERLAST_PRODUCT_ID = 8679662485717;
const EVERLAST_DOMESTIC_VARIANT_ID = 48798132273365;
const EVERLAST_INTERNATIONAL_VARIANT_ID = 48798132306133;
const EVERLAST_EXPEDITED_VARIANT_ID = "49700181803221";

window.addEventListener('resize', appDimension, { passive: true });
appDimension();

const stripHtmlAndSpaces = (html, limit) => {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || "";
    return limit ? text.slice(0, limit) : text;
}

const close_all_layers = (remain, closeMethod) => {
    window.mobileMenu?.close();  

    if (remain != 'cart') {
        close_slider_cart(closeMethod);
    }
}

const show_overlay = () => {
    $('.site_modal_overlay').fadeIn();
    disable_scrolling();
}

const hide_overlay = () => {
    $('.site_modal_overlay').fadeOut();
    enable_scrolling();
}

const disable_scrolling = () => {
    $('html').css('overflow', 'hidden');
}

const enable_scrolling = () => {
    $('html').css('overflow', 'initial');
}

const update_cart_content = () => {
    console.log('update slider cart/cart page');

    if (window.PXUTheme.template != 'cart') {
        show_cart_drawer_loading();
        // Prefer Sections API from root so aside-group settings (collections) resolve.
        // Fallback to legacy section_id HTML response.
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}?sections=cart-drawer`)
            .then((res) => {
                if (!res.ok) throw new Error('sections fetch failed');
                return res.json();
            })
            .then((data) => {
                const html = data && data['cart-drawer'];
                if (!html) throw new Error('cart-drawer section missing');
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const nextHolder = $(doc).find('#shopify-section-cart-drawer .section_holder');
                const currentHolder = $('#shopify-section-cart-drawer .section_holder');
                if (!nextHolder.length || !currentHolder.length) throw new Error('cart-drawer holder missing');
                currentHolder.attr('class', nextHolder.attr('class') || 'section_holder');
                currentHolder.html(nextHolder.html());
                hide_cart_drawer_loading();
            })
            .catch(() => {
                $.ajax({
                    url: `${root}?section_id=cart-drawer`,
                    type: 'GET'
                }).then((res) => {
                    const doc = new DOMParser().parseFromString(res, 'text/html');
                    const nextHolder = $(doc).find('#shopify-section-cart-drawer .section_holder');
                    const currentHolder = $('#shopify-section-cart-drawer .section_holder');
                    currentHolder.attr('class', nextHolder.attr('class') || 'section_holder');
                    currentHolder.html(nextHolder.html());
                    hide_cart_drawer_loading();
                }).catch(() => {
                    hide_cart_drawer_loading();
                });
            });
    }
}

const show_cart_drawer_loading = () => {
    $('.cd_loading_overlay').css('display', 'flex');
}

const hide_cart_drawer_loading = () => {
    $('.cd_loading_overlay').hide();
}

const update_collection_page_new_atcs = () => {
    fetch('/cart.js').then(res => res.json()).then(res => {
        const { items } = res
        const itemsArray = items.map(item => item.variant_id)
        $('.product-info-wrapper._related_atc_block_product_true .related_atc_block').each((i, elem) => {
            const elemVariantId = +elem.getAttribute('data-variant-id');
            if (itemsArray.includes(elemVariantId)) {
                elem.querySelector('.add').style.display = 'none'
                elem.querySelector('.added').style.display = 'block'
            } else {
                elem.querySelector('.add').style.display = 'block'
                elem.querySelector('.added').style.display = 'none'
            }
        })
        $('.collection-add-to-cart').each((i, elem) => {
            const elemVariantId = +elem.getAttribute('data-id');
            if (itemsArray.includes(elemVariantId)) {
                elem.innerHTML = 'ADDED'
            } else {
                elem.innerHTML = 'ADD TO CART'
            }
        })
      })
}

const update_header_icon = () => {
    console.log('update header icon');

    $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        const { item_count } = res;
        document.querySelectorAll('[data-bind="itemCount"]').forEach((element) => {
            element.innerHTML = item_count;
            if (+item_count > 0) {
                $(element).show();
            } else {
                $(element).hide();
            }
        });
    }).catch(error => {
        console.error('Error fetching cart:', error);
    });
}

const update_line_item = (key, quantity, from = 'normal') => {
    show_cart_drawer_loading();
    const updates = {
        [key]: quantity
    };

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates, sections: ['cart-drawer', 'header-classic'] })
    })
        .then(res => res.json())
        .then(res => {
            console.log(res);
            $('#shopify-section-cart-drawer .section_holder').html($(res.sections['cart-drawer']).find('.section_holder').html());

            hide_cart_drawer_loading();

            const { item_count } = res
            document.querySelectorAll('[data-bind="itemCount"]').forEach((element) => {
                element.innerHTML = item_count;
                if (+item_count > 0) {
                    $(element).show();
                } else {
                    $(element).hide();
                }
            });
            update_collection_page_new_atcs();
        })
}

const updateEverlastRxProceedButton = () => {
    const $button = $('.everlast_rx_email_popup_overlay .proceed');
    if (!$button.length) return;
    $button.text(everlastState.rxChanged ? 'CONTINUE' : 'SUBMIT');
}

const buildEverlastRxLineItems = () => {
    return everlastState.selectedRxLineItems.map(elem => {
        return {
            lineId: elem.lineId,
            productTitle: elem.productTitle,
            variantTitle: elem.variantTitle,
            productId: elem.productId,
            variantId: elem.variantId,
            thumbnail: elem.variantThumbnail,
            originOrderId: elem.originOrderNumber.split('/').pop(),
            originVariantId: elem.originVariantNumber,
            originProductId: elem.originProductNumber,
            originOrderName: elem.originOrderNumberAsNumber
        }
    });
}

const submitEverlastRxClaim = (payload, $submitButton, onSuccessClose) => {
    if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
      EverlastLogger.logInteraction('rx_claim_submit', {
        lineItemCount: payload.lineItems.length,
        rxChanged: payload.rxChanged,
        hasUpload: !!(payload.rxInformation && payload.rxInformation.uploadImage),
      });
    }

    const originalButtonText = $submitButton.data('original-text') || $submitButton.text();
    $submitButton.data('original-text', originalButtonText);
    $submitButton.html('<span class="loader"></span>');
    $submitButton.css('background-color', 'black');

    return everlastTrackedFetch('everlast_rx_order_submit', 'https://api.neveneyewear.com/api/send-email/everlast-rx-order', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ order: payload })
    })
        .then(async res => {
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                const err = new Error(body.msg || `HTTP ${res.status}`);
                err.userMessage = body.msg;
                err.code = body.code;
                throw err;
            }
            return body;
        })
        .then(res => {
            if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
              EverlastLogger.logInteraction('rx_claim_submit_result', { success: true });
            }
            onSuccessClose();
            enable_scrolling();
            resetEverlastForm();
            alert('Your RX Everlast claim was sent successfully!');
        })
        .catch(err => {
            if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
              EverlastLogger.logInteraction('rx_claim_submit_result', { success: false, error: err?.message || String(err), code: err?.code });
            }
            // Our team was emailed and will finish the claim by hand, so don't invite a resubmit.
            if (err?.code === 'rx_needs_review') {
                onSuccessClose();
                enable_scrolling();
                resetEverlastForm();
            }
            alert(err?.userMessage || 'An error occurred while sending your RX Everlast claim. Please try again.');
        })
        .finally(() => {
            $submitButton.html(originalButtonText);
            $submitButton.css('background-color', 'black');
        });
}

const openEverlastRxConfirmation = (orderItems) => {
    let productBlock = '<div class="header"><div class="col">PRODUCT</div><div class="col">DESCRIPTION</div><div class="col">PRICE</div><div class="col"></div></div>'
    orderItems.map(elem => {
        // const uniqueId = `${elem.originOrderNumberAsNumber}-${elem.originProductNumber}-${elem.productId}`;
        const  uniqueId = elem.lineId;
        productBlock += `
            <div class="everlast_rx_email_product_block">
                <div class="image">
                    <image src="${elem.variantThumbnail}" alt="${elem.variantTitle}" />
                </div>
                <div class="title">
                    <div class="product_title">${elem.productTitle}</div>
                    <div class="variant_title">${elem.variantTitle}</div>
                    ${elem.isAlternative ? `<div class="alternative">From ${elem.originProductTitle} in ${elem.originOrderNumberAsNumber}</div>` : ''}
                </div>
                <div class="price">
                    <div>${elem.variantPrice}</div>
                </div>
                <div class="cancel-product" onclick="remove_everlast_rx_product_from_list('${uniqueId}')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5" viewBox="0 0 13.5 13.5"><path id="Icon_ionic-md-close" data-name="Icon ionic-md-close" d="M21.023,8.873l-1.35-1.35-5.4,5.4-5.4-5.4-1.35,1.35,5.4,5.4-5.4,5.4,1.35,1.35,5.4-5.4,5.4,5.4,1.35-1.35-5.4-5.4Z" transform="translate(-7.523 -7.523)" fill="#fff"></path></svg>
                </div>
            </div>
        `
    })

    $('.everlast_rx_email_popup_overlay .everlast_rx_email_product_blocks').html(productBlock);
    $('#everlast-rx-email-rx-changed-checkbox').prop('checked', false);
    everlastState.rxChanged = false;
    updateEverlastRxProceedButton();
    $('.everlast_rx_email_popup_overlay').show();
    disable_scrolling();
    $('.everlast_rx_email_popup_overlay .proceed').off('click').click(() => {
        const reason = stripHtmlAndSpaces($('#everlast_rx_email_reason_textarea').val(), 2000);

        if (reason.length < 15) {
            if (reason.length == 0) $('.everlast_rx_email_reason_error').html('Let us know what happened to your Nevens.');
            else $('.everlast_rx_email_reason_error').html('This field is too short!');
            $('.everlast_rx_email_reason_error').show();
            $('#everlast_rx_email_reason_textarea').css('border', '2px solid red');
            return;
        }

        $('.everlast_rx_email_reason_error').html('');
        $('.everlast_rx_email_reason_error').hide();
        $('#everlast_rx_email_reason_textarea').css('border', '1px solid gray');

        everlastState.reason = reason;
        if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
          EverlastLogger.logInteraction('rx_reason_submit', {
            reasonLength: reason.length,
            rxChanged: everlastState.rxChanged,
          });
        }

        if (everlastState.rxChanged) {
            $('.everlast_rx_email_popup_overlay').hide();
            openEverlastRxInfoModal();
            return;
        }

        const payload = {
            customerEmail: everlastState.email,
            customerName: everlastState.customerName,
            expediteProcessing: everlastState.expeditedProcessing,
            reason: everlastState.reason,
            rxChanged: false,
            lineItems: buildEverlastRxLineItems()
        };

        submitEverlastRxClaim(
            payload,
            $('.everlast_rx_email_popup_overlay .proceed'),
            () => { $('.everlast_rx_email_popup_overlay').hide(); }
        );
    })
}

const remove_everlast_rx_product_from_list = (variantId) => {
    toggle_everlast_rx_product_by_unique_id(variantId);
    openEverlastRxConfirmation(everlastState.selectedRxLineItems);
    if (!everlastState.selectedRxLineItems.length) {
        $('.everlast_rx_email_popup_overlay').hide();
        enable_scrolling()
    }
}

// RX Info Modal State
const everlastRxInfoState = {
    uploadMessage: null,
    uploaderFileState: {
        files: null,
        imageUrl: ''
    },
    errors: {
        rightSphere: null,
        rightCylinder: null,
        rightAxis: null,
        leftSphere: null,
        leftCylinder: null,
        leftAxis: null,
        pd: null
    },
    hasError: true
}

const openEverlastRxInfoModal = () => {
  // hide/show ADD according to progressive
  const hasProgressive = everlastState.selectedRxLineItems.some(item => {
    return item.variantTitle.toLowerCase().includes('progressive');
  })

  if (hasProgressive) {
    $('#everlast-right-add').closest('.everlast_rx_info_field').show();
    $('#everlast-left-add').closest('.everlast_rx_info_field').show();
  } else {
    $('#everlast-right-add').closest('.everlast_rx_info_field').hide();
    $('#everlast-left-add').closest('.everlast_rx_info_field').hide();
  }
  
  // Reset form
  $('#everlast-right-sphere').val('');
  $('#everlast-right-cylinder').val('');
  $('#everlast-right-axis').val('');
  $('#everlast-right-add').val('');
  $('#everlast-left-sphere').val('');
  $('#everlast-left-cylinder').val('');
  $('#everlast-left-axis').val('');
  $('#everlast-left-add').val('');
  $('#everlast-pd-single').val('');
  $('#everlast-pd-left').val('');
  $('#everlast-pd-right').val('');
  $('#everlast-pd-1').addClass('active');
  $('#everlast-pd-2').removeClass('active');
  $('#everlast-pd-single-wrapper').show();
  $('#everlast-pd-double-wrapper').hide();
  $('#everlast-pd-right-wrapper').hide();
  $('.everlast_rx_info_uploader').removeClass('uploaded');
  $('.everlast_rx_info_upload_preview').removeClass('active');
  $('#everlast-rx-uploader').val(null);
  $('#everlast-read-and-fill-uploaded').hide();
  everlastRxInfoState.uploadMessage = null;
  everlastRxInfoState.uploaderFileState = { files: null, imageUrl: '' };
  
  // Hide all errors
  $('.everlast_rx_info_field .rx-product-submit-error').removeClass('active');
  
  $('.everlast_rx_info_popup_overlay').show();
  disable_scrolling();
  
  // Setup PD toggle
  $('#everlast-pd-1, #everlast-pd-2').off('click').on('click', function() {
    $('#everlast-pd-1, #everlast-pd-2').removeClass('active');
    $(this).addClass('active');
    const pdValue = $(this).data('value');
    if (pdValue === '1' || pdValue === 1) {
      $('#everlast-pd-single-wrapper').show();
      $('#everlast-pd-double-wrapper').hide();
      $('#everlast-pd-right-wrapper').hide();
      $('#everlast-pd-left').val('');
      $('#everlast-pd-right').val('');
    } else {
      $('#everlast-pd-single-wrapper').hide();
      $('#everlast-pd-double-wrapper').show();
      $('#everlast-pd-right-wrapper').show();
      $('#everlast-pd-single').val('');
    }
    // Clear PD errors
    $('#everlast-pd-single-error, #everlast-pd-left-error, #everlast-pd-right-error').removeClass('active');
  });
  
  // Setup PD field change handlers
  $('#everlast-pd-single, #everlast-pd-left, #everlast-pd-right').off('change').on('change', function() {
    if ($(this).val() !== '') {
      $(this).closest('.everlast_rx_info_field').find('.rx-product-submit-error').removeClass('active');
    }
  });
  
  // Setup file upload
  $('#everlast-rx-uploader').off('change').on('change', function(e) {
    const uploaderWrapper = $('.everlast_rx_info_uploader');
    const uploaderMessage = $('.everlast_rx_info_upload_message');
    const uploadPreview = $('.everlast_rx_info_upload_preview');
    uploaderWrapper.addClass('uploading');
    uploaderWrapper.removeClass('uploaded');
    
    const formdata = new FormData();
    let isPermittedToUpload = true;
    const permittedExtensions = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif', 'image/avif', 'application/pdf'];
    
    if (this.files.length > 0) {
      if (!permittedExtensions.includes(this.files[0].type)) {
        uploaderWrapper.addClass('uploaded');
        uploaderMessage.css('color', 'red');
        uploaderMessage.text('The chosen file must be image or PDF, you selected file type is ' + this.files[0].type);
        isPermittedToUpload = false;
        uploadPreview.removeClass('active');
        everlastRxInfoState.uploadMessage = null;
      }
      if (this.files[0].size > 7340032) {
        uploaderWrapper.addClass('uploaded');
        uploaderMessage.css('color', 'red');
        uploaderMessage.text('The chosen file must be lower or equal than 7MB, your selected file is equal to ' + parseFloat((this.files[0].size) / 1048576).toFixed(2) + ' MB');
        isPermittedToUpload = false;
        uploadPreview.removeClass('active');
        everlastRxInfoState.uploadMessage = null;
      }
      if (!isPermittedToUpload) {
        uploaderWrapper.removeClass('uploading');
        return;
      }
      
      uploaderWrapper.removeClass('uploaded');
      Array.from(this.files).forEach((file) => {
        formdata.append("files[]", file);
      });
      
      const requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };
      
      everlastTrackedFetch('everlast_rx_upload_image', "https://api.neveneyewear.com/api/upload/image", requestOptions)
        .then(response => response.json())
        .then(data => {
          if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
            EverlastLogger.logInteraction('rx_prescription_upload', { success: data.success === 'success' });
          }
          if (data.success === 'success') {
            uploaderMessage.text('');
            uploaderMessage.css('color', '');
            everlastRxInfoState.uploaderFileState.files = this.files;
            everlastRxInfoState.uploaderFileState.imageUrl = data.data.imageUrl;
            everlastRxInfoState.uploadMessage = "https://api.neveneyewear.com/" + data.data.imageUrl;
            uploaderWrapper.addClass('uploaded');
            uploadPreview.addClass('active');
            $('#everlast-read-and-fill-uploaded').show().prop('disabled', false).text('Read and Fill');
            uploadPreview.find('span').text(this.files[0].name);
            
            $('#everlast-edit-uploaded').off('click').on('click', function() {
              everlastRxInfoState.uploadMessage = null;
              everlastRxInfoState.uploaderFileState = { files: null, imageUrl: '' };
              uploaderWrapper.removeClass('uploaded');
              uploadPreview.removeClass('active');
              $('#everlast-read-and-fill-uploaded').hide();
              $('#everlast-rx-uploader').val(null);
            });
            
            $('#everlast-preview-uploaded').off('click').on('click', function() {
              if (everlastRxInfoState.uploadMessage.includes('jpeg') || everlastRxInfoState.uploadMessage.includes('png') || everlastRxInfoState.uploadMessage.includes('jpg') || everlastRxInfoState.uploadMessage.includes('webp') || everlastRxInfoState.uploadMessage.includes('gif') || everlastRxInfoState.uploadMessage.includes('avif')) {
                window.open(everlastRxInfoState.uploadMessage, '_blank');
              } else {
                window.open(everlastRxInfoState.uploadMessage);
              }
            });

            $('#everlast-read-and-fill-uploaded').off('click').on('click', async function(e) {
              e.preventDefault();
              e.stopPropagation();
              const btn = $('#everlast-read-and-fill-uploaded');
              const originalText = btn.text();
              const url = everlastRxInfoState.uploadMessage;
              if (!url) return;

              btn.prop('disabled', true).text('Reading...');
              try {
                const res = await fetch('https://api.neveneyewear.com/api/rx-ocr', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ url, imageUrl: url })
                });
                const payload = await res.json();
                const ocr = payload?.data ?? payload;

                const getVal = (obj, ...keys) => {
                  for (const k of keys) {
                    if (obj && obj[k] != null && obj[k] !== '') return obj[k];
                  }
                  return null;
                };
                const normalizeQuarterLens = (v) => {
                  const n = parseFloat(v);
                  if (isNaN(n)) return null;
                  const rounded = Math.round(n * 4) / 4;
                  let s = rounded.toFixed(2);
                  if (s.endsWith('0')) s = s.slice(0, -1);
                  return s;
                };
                const normalizeAxis = (v) => {
                  const n = parseFloat(v);
                  if (isNaN(n)) return null;
                  return String(Math.round(n));
                };
                const normalizePdSelect = (v) => {
                  const n = parseFloat(v);
                  if (isNaN(n)) return null;
                  const rounded = Math.round(n * 4) / 4;
                  const isInt = Math.abs(rounded - Math.round(rounded)) < 1e-9;
                  if (isInt) return String(Math.round(rounded));
                  let s = rounded.toFixed(2);
                  if (s.endsWith('0')) s = s.slice(0, -1);
                  return s;
                };

                const rightSphereVal = normalizeQuarterLens(getVal(ocr, 'right_sphere', 'od_sphere', 'rightSphere'));
                const rightCylinderVal = normalizeQuarterLens(getVal(ocr, 'right_cylinder', 'od_cylinder', 'rightCylinder'));
                const rightAxisVal = normalizeAxis(getVal(ocr, 'right_axis', 'od_axis', 'rightAxis'));
                const rightAddVal = normalizeQuarterLens(getVal(ocr, 'right_add', 'od_add', 'rightAdd'));
                const leftSphereVal = normalizeQuarterLens(getVal(ocr, 'left_sphere', 'os_sphere', 'leftSphere'));
                const leftCylinderVal = normalizeQuarterLens(getVal(ocr, 'left_cylinder', 'os_cylinder', 'leftCylinder'));
                const leftAxisVal = normalizeAxis(getVal(ocr, 'left_axis', 'os_axis', 'leftAxis'));
                const leftAddVal = normalizeQuarterLens(getVal(ocr, 'left_add', 'os_add', 'leftAdd'));
                const pdLeftVal = normalizePdSelect(getVal(ocr, 'pd_left', 'left_pd', 'pdLeft'));
                const pdRightVal = normalizePdSelect(getVal(ocr, 'pd_right', 'right_pd', 'pdRight'));
                const pdTotalVal = getVal(ocr, 'pd', 'total_pd', 'totalPd');

                const setField = ($el, val) => {
                  if (val == null) return;
                  $el.val(val);
                  $el.trigger('change');
                };

                if (pdLeftVal != null && pdRightVal != null && pdLeftVal !== '' && pdRightVal !== '') {
                  $('#everlast-pd-2').trigger('click');
                  setField($('#everlast-pd-left'), pdLeftVal);
                  setField($('#everlast-pd-right'), pdRightVal);
                } else if (pdTotalVal != null && pdTotalVal !== '') {
                  $('#everlast-pd-1').trigger('click');
                  const pdNum = parseFloat(pdTotalVal);
                  if (!isNaN(pdNum)) setField($('#everlast-pd-single'), String(pdNum));
                }

                setField($('#everlast-right-sphere'), rightSphereVal);
                setField($('#everlast-right-cylinder'), rightCylinderVal);
                setField($('#everlast-right-axis'), rightAxisVal);
                setField($('#everlast-right-add'), rightAddVal);
                setField($('#everlast-left-sphere'), leftSphereVal);
                setField($('#everlast-left-cylinder'), leftCylinderVal);
                setField($('#everlast-left-axis'), leftAxisVal);
                setField($('#everlast-left-add'), leftAddVal);
                if (typeof openSuccessToast === 'function') {
                  openSuccessToast('Success', {
                    errors: {
                      message: 'Successfully read the prescription and filled in the fields. Please check if the information is correct.'
                    }
                  })
                }
              } catch (err) {
                console.error(err);
              } finally {
                btn.prop('disabled', false).text(originalText);
              }
            });
          }
        })
        .catch(error => {
          console.log('error', error);
          uploaderWrapper.addClass('uploaded');
          uploaderMessage.text('Something went wrong. Please try again later.');
          uploaderMessage.css('color', 'red');
        })
        .finally(() => {
          uploaderWrapper.removeClass('uploading');
        });
    } else {
      uploaderWrapper.removeClass('uploading');
    }
  });
  
  // Setup select change handlers to clear errors
  $('#everlast-right-sphere, #everlast-right-cylinder, #everlast-right-axis, #everlast-right-add, #everlast-left-sphere, #everlast-left-cylinder, #everlast-left-axis, #everlast-left-add').off('change').on('change', function() {
    if ($(this).val() !== '') {
      $(this).closest('.everlast_rx_info_field').find('.rx-product-submit-error').removeClass('active');
    }
  });
  
  // Setup Submit button
  $('.everlast_rx_info_popup_button.proceed').off('click').on('click', function() {
      validateAndSubmitEverlastRxInfo();
  });
}

const validateAndSubmitEverlastRxInfo = () => {
    // Reset errors
    everlastRxInfoState.hasError = false;
    $('.everlast_rx_info_field .rx-product-submit-error').removeClass('active');
    // check if any of the selected items is progressive
    const hasProgressive = everlastState.selectedRxLineItems.some(item => {
        return item.variantTitle.toLowerCase().includes('progressive');
    })

    const rightSphere = $('#everlast-right-sphere').val();
    const rightCylinder = $('#everlast-right-cylinder').val();
    const rightAxis = $('#everlast-right-axis').val();
    const rightAdd = $('#everlast-right-add').val();
    const leftSphere = $('#everlast-left-sphere').val();
    const leftCylinder = $('#everlast-left-cylinder').val();
    const leftAxis = $('#everlast-left-axis').val();
    const leftAdd = $('#everlast-left-add').val();
    
    // Validate right eye
    if (rightSphere === '' || rightSphere === null) {
        $('#everlast-right-sphere-error').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (rightCylinder === '' || rightCylinder === null) {
        $('#everlast-right-cylinder-error').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (rightAxis === '' || rightAxis === null) {
        $('#everlast-right-axis-error').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (hasProgressive) {
      if (rightAdd === '' || rightAdd === null) {
        $('#everlast-right-add-error').addClass('active');
        everlastRxInfoState.hasError = true;
      }
    } else {
      $('#everlast-right-add-error').removeClass('active');
    }
    
    // Validate left eye
    if (leftSphere === '' || leftSphere === null) {
        $('#everlast-left-sphere-error').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (leftCylinder === '' || leftCylinder === null) {
        $('#everlast-left-cylinder-error').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (leftAxis === '' || leftAxis === null) {
        $('#everlast-left-axis-error').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (hasProgressive) {
      if (leftAdd === '' || leftAdd === null) {
          $('#everlast-left-add-error').addClass('active');
          everlastRxInfoState.hasError = true;
      }
    } else {
      $('#everlast-left-add-error').removeClass('active');
    }
    
    // Validate cylinder/axis relationship (axis 180 allows cylinder 0)
    if (+rightCylinder !== 0 && +rightAxis === 0) {
        $('#everlast-right-axis-error').text('Axis should not be 0 when Cylinder has a value').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (+rightAxis !== 0 && +rightAxis !== 180 && +rightCylinder === 0) {
        $('#everlast-right-cylinder-error').text('Cylinder should not be 0 when Axis has a value').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (+leftCylinder !== 0 && +leftAxis === 0) {
        $('#everlast-left-axis-error').text('Axis should not be 0 when Cylinder has a value').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    if (+leftAxis !== 0 && +leftAxis !== 180 && +leftCylinder === 0) {
        $('#everlast-left-cylinder-error').text('Cylinder should not be 0 when Axis has a value').addClass('active');
        everlastRxInfoState.hasError = true;
    }
    
    // Validate PD
    const pdType = $('.everlast_rx_info_pd_number.active').data('value');
    let pdValue = null;
    let pdLeft = null;
    let pdRight = null;
    
    if (pdType === '1' || pdType === 1) {
        pdValue = $('#everlast-pd-single').val();
        if (pdValue === '' || pdValue === null) {
            $('#everlast-pd-single-error').addClass('active');
            everlastRxInfoState.hasError = true;
        } else if (parseFloat(pdValue) < 30 || parseFloat(pdValue) > 80) {
            $('#everlast-pd-single-error').text('PD is outside the allowed range (30-80)').addClass('active');
            everlastRxInfoState.hasError = true;
        } else {
            pdLeft = pdValue / 2;
            pdRight = pdValue / 2;
        }
    } else {
        pdLeft = $('#everlast-pd-left').val();
        pdRight = $('#everlast-pd-right').val();
        const pdSum = parseFloat(pdLeft) + parseFloat(pdRight);
        if (pdLeft === '' || pdLeft === null) {
            $('#everlast-pd-left-error').addClass('active');
            everlastRxInfoState.hasError = true;
        }
        if (pdRight === '' || pdRight === null) {
            $('#everlast-pd-right-error').addClass('active');
            everlastRxInfoState.hasError = true;
        }
        if (pdSum < 30 || pdSum > 80) {
            $('#everlast-pd-left-error').text('PD is outside the allowed range (30-80)').addClass('active');
            $('#everlast-pd-right-error').text('PD is outside the allowed range (30-80)').addClass('active');
            everlastRxInfoState.hasError = true;
        }
    }
    
    if (everlastRxInfoState.hasError) {
        return;
    }
    
    // Build RX data
    const rxData = {
        rightSphere: rightSphere,
        rightCylinder: rightCylinder,
        rightAxis: rightAxis,
        rightAdd: rightAdd,
        leftSphere: leftSphere,
        leftCylinder: leftCylinder,
        leftAxis: leftAxis,
        leftAdd: leftAdd,
        pdType: pdType,
        pdValue: pdType === '1' || pdType === 1 ? pdValue : null,
        pdLeft: pdType === '2' || pdType === 2 ? pdLeft : null,
        pdRight: pdType === '2' || pdType === 2 ? pdRight : null,
        uploadImage: everlastRxInfoState.uploadMessage
    };

    // Build line items payload in original format
    const lineItems = buildEverlastRxLineItems();

    // Build final payload (includes RX information)
    const payload = {
        customerEmail: everlastState.email,
        customerName: everlastState.customerName,
        expediteProcessing: everlastState.expeditedProcessing,
        reason: everlastState.reason,
        rxChanged: true,
        rxInformation: rxData,
        lineItems
    };

    submitEverlastRxClaim(
        payload,
        $('.everlast_rx_info_popup_button.proceed'),
        () => { $('.everlast_rx_info_popup_overlay').hide(); }
    );
}

const openEverlastSunglassConfirmation = (orderItems) => {
    let productBlock = '<div class="header"><div class="col">PRODUCT</div><div class="col">DESCRIPTION</div><div class="col">PRICE</div><div class="col"></div></div>'
    orderItems.map(elem => {
        // const uniqueId = `${elem.originOrderNumberAsNumber}-${elem.originProductNumber}-${elem.productId}`;
        const  uniqueId = elem.lineId;
        productBlock += `
            <div class="everlast_sunglass_confirm_product_block">
                <div class="image">
                    <image src="${elem.variantThumbnail}" alt="${elem.variantTitle}" />
                </div>
                <div class="title">
                    <div class="product_title">${elem.productTitle}</div>
                    <div class="variant_title">${elem.variantTitle}</div>
                    ${elem.isAlternative ? `<div class="alternative">From ${elem.originProductTitle} in ${elem.originOrderNumberAsNumber}</div>` : ''}
                </div>
                <div class="price">
                    <div>${elem.variantPrice}</div>
                </div>
                <div class="cancel-product" onclick="remove_everlast_sunglass_product_from_list('${uniqueId}')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5" viewBox="0 0 13.5 13.5"><path id="Icon_ionic-md-close" data-name="Icon ionic-md-close" d="M21.023,8.873l-1.35-1.35-5.4,5.4-5.4-5.4-1.35,1.35,5.4,5.4-5.4,5.4,1.35,1.35,5.4-5.4,5.4,5.4,1.35-1.35-5.4-5.4Z" transform="translate(-7.523 -7.523)" fill="#fff"></path></svg>
                </div>
            </div>
        `
    })

    $('.everlast_sunglass_confirm_popup_overlay .everlast_sunglass_confirm_product_blocks').html(productBlock);
    if (everlastState.selectedOrderCountry !== 'United States') {
        $('.everlast_sunglass_confirm_shipping_location').show();
        $('.everlast_sunglass_confirm_review').hide();
    } else {
        everlastState.userSetOrderCountry = everlastState.selectedOrderCountry
    }
    $('.everlast_sunglass_confirm_popup_overlay').show();
    disable_scrolling();
    $('.everlast_sunglass_confirm_popup_overlay .proceed').off('click').click(() => {
        const reason = stripHtmlAndSpaces($('#everlast_sunglass_confirm_reason_textarea').val(), 2000);

        // if (reason.length > 200) {
        //     $('.everlast_sunglass_confirm_reason_error').html('This field is too long!');
        //     $('.everlast_sunglass_confirm_reason_error').show();
        //     $('#everlast_sunglass_confirm_reason_textarea').css('border', '2px solid red');
        //     return;
        // }

        if (reason.length < 15) {
            if (reason.length == 0) $('.everlast_sunglass_confirm_reason_error').html('Let us know what happened to your Nevens.');
            else $('.everlast_sunglass_confirm_reason_error').html('This field is too short!');
            $('.everlast_sunglass_confirm_reason_error').show();
            $('#everlast_sunglass_confirm_reason_textarea').css('border', '2px solid red');
            return;
        }

        $('.everlast_sunglass_confirm_reason_error').html('');
        $('.everlast_sunglass_confirm_reason_error').hide();
        $('#everlast_sunglass_confirm_reason_textarea').css('border', '1px solid gray');

        everlastState.reason = reason;
        if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
          EverlastLogger.logInteraction('sunglass_reason_submit', {
            reasonLength: reason.length,
            orderCountry: everlastState.userSetOrderCountry,
            itemCount: orderItems.length,
          });
        }

        $('.everlast_sunglass_confirm_popup_overlay .proceed').html("<span class=\"loader\"></span>");
        $('.everlast_sunglass_confirm_popup_overlay .proceed').css('background-color', 'black')

        const handler = () => {
            if (typeof everlastVariantMapsReady !== 'undefined' && !everlastVariantMapsReady) {
                console.error('Everlast variant maps are not ready');
                $('.everlast_sunglass_confirm_popup_overlay .proceed').html("Checkout");
                return;
            }

            const items = [];
            const missingVariantIds = [];
            const email = everlastState.email;
            const orderCountry = everlastState.userSetOrderCountry;

            orderItems.forEach((variant) => {
                const replacementVariantId = orderCountry === 'United States'
                    ? everlast_dom_variant_metafields[variant.variantId]
                    : everlast_intl_variant_metafields[variant.variantId];

                if (!replacementVariantId) {
                    missingVariantIds.push(variant.variantId);
                    return;
                }

                items.push({
                    id: replacementVariantId,

                    quantity: 1,
                    properties: {
                        '__everlast_product': 'true',
                        '__customer_email': email,
                        '__order_number': variant.originOrderNumber,
                        '__order_name': variant.originOrderNumberAsNumber,
                        '__order_variant_id': variant.originVariantNumber,
                        // '__order_line_id': variant.lineId,
                        '__dom_variant': orderCountry === 'United States' ? 'true' : 'false',
                        '__int_variant': orderCountry === 'United States' ? 'false' : 'true',
                        '__variant_id': variant.variantId,
                        '__variant_title': variant.variantTitle,
                        '__variant_rx': variant.variantIsRx,
                        '__variant_price': variant.variantPrice,
                        '__variant_thumbnail': variant.variantThumbnail,
                        '__product_id': variant.productId,
                        '__product_title': variant.productTitle,
                        '__hq_pick_post': variant.hqPickSpot
                    }
                });
            })

            if (missingVariantIds.length) {
                const mappingError = {
                    message: 'Everlast variant ids were not correctly populated',
                    orderCountry,
                    variantIds: missingVariantIds,
                    domesticMapCount: Object.keys(everlast_dom_variant_metafields || {}).length,
                    internationalMapCount: Object.keys(everlast_intl_variant_metafields || {}).length,
                    mapsReady: typeof everlastVariantMapsReady !== 'undefined' ? everlastVariantMapsReady : null,
                };
                console.error('Everlast variant ids were not correctly populated', mappingError);
                if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
                    EverlastLogger.logInteraction('variant_mapping_missing', mappingError);
                }
                $('.everlast_sunglass_confirm_popup_overlay .proceed').html("Checkout");
                return;
            }

            if (everlastState.expeditedProcessing) {
                items.push({
                    id: EVERLAST_EXPEDITED_VARIANT_ID,
                    quantity: 1,
                    // properties: {
                    //     '__everlast_product': 'true',
                    //     '__customer_email': email,
                    //     '__variant_id': EVERLAST_EXPEDITED_VARIANT_ID,
                    //     '__variant_title': "Expedited Processing",
                    //     '__product_title': "Expedited Processing",
                    // }
                })
            }

            const malformedItems = items.filter((item) => !item || item.id === undefined || item.id === null || item.id === '');
            if (malformedItems.length || !items.length) {
                const malformedError = {
                    message: 'Everlast variant ids were not correctly populated',
                    reason: 'malformed_create_order_token',
                    orderCountry,
                    itemCount: items.length,
                    malformedCount: malformedItems.length,
                    malformedItems,
                    items,
                    domesticMapCount: Object.keys(everlast_dom_variant_metafields || {}).length,
                    internationalMapCount: Object.keys(everlast_intl_variant_metafields || {}).length,
                    mapsReady: typeof everlastVariantMapsReady !== 'undefined' ? everlastVariantMapsReady : null,
                };
                console.error('Everlast variant ids were not correctly populated', malformedError);
                if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
                    EverlastLogger.logInteraction('create_order_token_malformed', malformedError);
                }
                $('.everlast_sunglass_confirm_popup_overlay .proceed').html("Checkout");
                return;
            }

            let customerId = ''

            if (window.nvnCustomerId) {
                customerId = String(window.nvnCustomerId);
            }
            

            everlastTrackedFetch('everlast_create_order_token', 'https://api.neveneyewear.com/api/everlast/create-order-token',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items,
                        note: everlastState.reason,
                        customerId,
                        sessionId: window.EverlastLogger ? EverlastLogger.getSessionId() : null
                    })
                }
            )
            .then(res => res.json())
            .then((res) => {
                if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
                  EverlastLogger.logInteraction('sunglass_checkout_redirect', { hasToken: !!res.token });
                }
                const newPage = `https://everlast.neveneyewear.com?token=${res.token}`
                // window.open(newPage, '_blank').focus()
                setTimeout(() => {
                    location.href = newPage
                }, 500);
                location.href = newPage
                return false;
            })
            .catch((err) => {
                if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
                  EverlastLogger.logInteraction('sunglass_checkout_redirect', { success: false, error: err?.message || String(err) });
                }
                $('.everlast_sunglass_confirm_popup_overlay .proceed').html("Checkout");
            })
            .finally(() => {
            })
        }

        var showWipe = false
        
        if (!showWipe) {
            handler()
        }

        $('button.button.is-within-form').html("REVIEW MY CLAIM");
    })
}

const remove_everlast_sunglass_product_from_list = (uniqueId) => {
    toggle_everlast_sunglass_product_by_unique_id(uniqueId);
    openEverlastSunglassConfirmation(everlastState.selectedSunglassLineItems);
    if (!everlastState.selectedSunglassLineItems.length) {
        $('.everlast_sunglass_confirm_popup_overlay').hide();
        enable_scrolling()
    }
}

const openEverlastModal = async (selectedVariants, email, orderNumber, orderCountry, isExpedited) => {
    show_cart_drawer_loading();

    const rxVariants = selectedVariants.filter((elem) => {
        if (elem.variantIsRx === true || elem.variantIsRx === 'true') {
            return true
        }
    })

    const sunglassVariants = selectedVariants.filter((elem) => {
        if (elem.variantIsRx === 'false' || elem.variantIsRx === false) {
            return true
        }
    })

    if (rxVariants.length) {
        openEverlastRxConfirmation(rxVariants)
        hide_cart_drawer_loading()
        return
    }

    if (sunglassVariants.length) {
        openEverlastSunglassConfirmation(sunglassVariants)
        hide_cart_drawer_loading()
        return
    }

    // selectedVariants.forEach((variant) => {
    //     items.push({
    //         id: orderCountry === 'United States' ? EVERLAST_DOMESTIC_VARIANT_ID : EVERLAST_INTERNATIONAL_VARIANT_ID,
    //         quantity: 1,
    //         properties: {
    //             '__everlast_product': 'true',
    //             '__customer_email': email,
    //             '__order_number': variant.originOrderNumber,
    //             '__order_variant_id': variant.originVariantNumber,
    //             '__dom_variant': orderCountry === 'United States' ? 'true' : 'false',
    //             '__int_variant': orderCountry === 'United States' ? 'false' : 'true',
    //             '__variant_id': variant.variantId,
    //             '__variant_title': variant.variantTitle,
    //             '__variant_rx': variant.variantIsRx,
    //             '__variant_price': variant.variantPrice,
    //             '__variant_thumbnail': variant.variantThumbnail,
    //             '__product_title': variant.productTitle,
    //         }
    //     });
    //     variantOriginInfo.push(variant.originOrderNumber + variant.originVariantNumber);
    // })

    // if (isExpedited === 'YES') {
    //     items.push({
    //         id: EVERLAST_EXPEDITED_VARIANT_ID,
    //         quantity: 1,
    //         properties: {
    //             '__everlast_product': 'true',
    //             '__customer_email': email,
    //             '__variant_id': EVERLAST_EXPEDITED_VARIANT_ID,
    //             '__variant_title': "Expedited Processing",
    //             '__product_title': "Expedited Processing",
    //         }
    //     })
    // }

    // let cartContainsOnlyEverlast = true;

    // const currentCartLineItems = window.cart.items;
    // // check if it contains non-everlast products, and if yes, empty the cart
    // for (let i = 0; i < currentCartLineItems.length; i++) {
    //     const item = currentCartLineItems[i];
    //     if (item.variant_id !== EVERLAST_EXPEDITED_VARIANT_ID && (item.properties.__everlast_product !== 'true' || !item.properties.__customer_email || !item.properties.__order_number)) {
    //         cartContainsOnlyEverlast = false
    //         break
    //     }
    // }

    // let updaterArray = [];
    // if (cartContainsOnlyEverlast) {
    //     console.log("variantOriginInfo", variantOriginInfo)
    //     const newCartLines = currentCartLineItems.filter(item => {
    //         if (!variantOriginInfo.includes(item.properties.__order_number + item.properties.__order_variant_id) && item.variant_id !== EVERLAST_EXPEDITED_VARIANT_ID) return true;
    //         else return false;
    //     })
    //     console.log('Cart already has everlast products. New lines: ', [...newCartLines, ...items])
    //     updaterArray = [...newCartLines, ...items]
    // } else {
    //     console.log("cart already includes other items - new content: ", items)
    //     updaterArray = items;
    // }
    // fetch('/cart/clear.js', { method: 'POST' }).then(res => res.json()).then(() => {
    //     $('button.button.is-within-form').html("Add To Cart");
    //     fetch('/cart/add.js', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({ items: updaterArray })
    //     })
    //         .then(res => res.json())
    //         .then(res => {
    //             update_cart_content();
    //             update_header_icon();
    //             open_slider_cart();
    //         })
    // })
}

const show_everlast_wipe_warning = (cb) => {
    $('.wipe_popup_overlay').show();
}

/* Slide Cart js */
const removeCartItem = (element) => {
    const variantId = element.dataset.id;

    update_line_item(variantId, 0);
}

const decreaseCartItem = (element) => {
    const variantId = element.dataset.id;
    const quantity = + element.dataset.quantity;
    update_line_item(variantId, quantity - 1);
}

const increaseCartItem = (element) => {
    const variantId = element.dataset.id;
    const quantity = + element.dataset.quantity;

    update_line_item(variantId, quantity + 1);
}

const addUpsellProduct = (element) => {
    const variantId = $(element).closest('.cart_drawer_upsell').find('select').val();
    const productHandle = $(element).closest('.cart_drawer_upsell').attr('data-handle');
    console.log('variantId: ', variantId);
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1,
                properties: {
                    _atc_source: `upsell:cart:${productHandle}`
                }
            }]
        })
    }).then(res => res.json()).then(res => {
        update_cart_content()
        update_header_icon()
    })
    // update_line_item(variantId, 1);
}

/* End of Slide Cart js */
function mergeProductJsonPages(data1, data2) {
    if (!data1 || !data1.product) return data1
    const p = data1.product
    const v1 = Array.isArray(p.variants) ? p.variants : []
    const v2 = data2 && data2.product && Array.isArray(data2.product.variants) ? data2.product.variants : []
    const seen = new Set()
    const merged = []
    for (const v of v1.concat(v2)) {
        if (v && v.id != null && !seen.has(v.id)) {
            seen.add(v.id)
            merged.push(v)
        }
    }
    return { product: Object.assign({}, p, { variants: merged }) }
}

function parseStorefrontProductJsonEndpoint(endpoint) {
    try {
        const u = new URL(endpoint, window.location.href)
        if (!/^\/products\/[^/]+\.json$/.test(u.pathname)) return null
        if (u.search && u.search !== '') return null
        const handle = u.pathname.replace(/^\/products\//, '').replace(/\.json$/, '')
        return { cacheKey: '/products/' + handle + '.json', handle: handle }
    } catch (e) {
        return null
    }
}

window.fetchProductJsonMerged = async function (endpoint) {
    const parsed = parseStorefrontProductJsonEndpoint(endpoint)
    if (parsed && window.sepStorefront && typeof window.sepStorefront.enabled === 'function' && window.sepStorefront.enabled()) {
        try {
            const data = await window.sepStorefront.productJsonByHandle(parsed.handle)
            if (data && data.product) return data
        } catch (e) {
            // fall through to Ajax .json
        }
    }
    if (!parsed) {
        const r = await fetch(endpoint)
        if (!r.ok) throw r
        return r.json()
    }
    const url1 = parsed.cacheKey
    const url2 = parsed.cacheKey + '?page=2'
    const [data1, data2] = await Promise.all([
        fetch(url1).then(function (r) {
            if (!r.ok) throw r
            return r.json()
        }),
        fetch(url2).then(function (r) {
            return r.ok ? r.json() : null
        }).catch(function () {
            return null
        })
    ])
    return mergeProductJsonPages(data1, data2)
}

window.fetchOphSplitProductJson = function (handle) {
  return window.fetchProductJsonMerged('/products/' + handle + '.json')
    .then(function (data) {
      return data && data.product ? data : null
    })
    .catch(function () {
      return null
    })
}

window.loadOphthalmicSplitProducts = function (pageProduct) {
  window.pdp.ophSplitBlProduct = null
  window.pdp.ophSplitPlProduct = null
  window.pdp.ophMainProduct = null
  window.pdp.ophSplitReady = { main: false, bl: false, pl: false }

  if (!pageProduct || !pageProduct.handle) return Promise.resolve()

  if (!window.isOphSplitPageProduct(pageProduct.handle, pageProduct.product_type)) {
    return Promise.resolve()
  }

  window.ensureOphSplitHandles(pageProduct.handle, pageProduct.product_type, pageProduct.id)

  const mh = window.pdp.ophMainHandle
  const bh = window.pdp.ophSplitBlHandle
  const ph = window.pdp.ophSplitPlHandle

  if (!mh || !bh || !ph) return Promise.resolve()

  // Assign by this product's handle, not ophSplitRole (role may stay on landing -bl/-pl
  // while this call is a canonical-main reload).
  const pageHandle = pageProduct.handle
  if (pageHandle === mh || (!pageHandle.endsWith('-bl') && !pageHandle.endsWith('-pl'))) {
    window.pdp.ophMainProduct = pageProduct
    window.pdp.ophSplitReady.main = true
  } else if (pageHandle === bh || pageHandle.endsWith('-bl')) {
    window.pdp.ophSplitBlProduct = pageProduct
    window.pdp.ophSplitReady.bl = true
  } else if (pageHandle === ph || pageHandle.endsWith('-pl')) {
    window.pdp.ophSplitPlProduct = pageProduct
    window.pdp.ophSplitReady.pl = true
  }

  const tasks = []
  if (!window.pdp.ophSplitReady.main) {
    tasks.push(
      window.fetchOphSplitProductJson(mh).then(function (data) {
        if (data && data.product) {
          window.pdp.ophMainProduct = data.product
          window.pdp.ophSplitReady.main = true
        }
      })
    )
  }
  if (!window.pdp.ophSplitReady.bl) {
    tasks.push(
      window.fetchOphSplitProductJson(bh).then(function (data) {
        if (data && data.product) {
          window.pdp.ophSplitBlProduct = data.product
          window.pdp.ophSplitBlHandle = data.product.handle
          window.pdp.ophSplitReady.bl = true
        }
      })
    )
  }
  if (!window.pdp.ophSplitReady.pl) {
    tasks.push(
      window.fetchOphSplitProductJson(ph).then(function (data) {
        if (data && data.product) {
          window.pdp.ophSplitPlProduct = data.product
          window.pdp.ophSplitPlHandle = data.product.handle
          window.pdp.ophSplitReady.pl = true
        }
      })
    )
  }

  return Promise.all(tasks).then(function () {
    document.dispatchEvent(new CustomEvent('oph-split:ready'))
  })
}

const fetchController = async (endpoint, dt = 'json') => {
    window.pdpFetchCache = window.pdpFetchCache || {}
    const parsed = dt === 'json' && typeof endpoint === 'string' ? parseStorefrontProductJsonEndpoint(endpoint) : null
    const cacheKey = parsed ? parsed.cacheKey : endpoint
    if (window.pdpFetchCache[cacheKey]) {
        return window.pdpFetchCache[cacheKey]
    }
    if (dt === 'json' && parsed) {
        const data = await window.fetchProductJsonMerged(endpoint)
        window.pdpFetchCache[cacheKey] = data
        return data
    }
    const response = await fetch(endpoint)
    const data = dt == 'json' ? await response.json() : await response.text()
    window.pdpFetchCache[endpoint] = data
    return data
}

class FacetHeading extends HTMLElement {
    constructor() {
        super()
        this.sliderKeys = [];

        this.addEventListener('click', this.showContent.bind(this));
    }

    showContent = (e) => {
        if (e.target != this.querySelector('.tab-action-clear-filter')) {
            const parent = this.parentNode;
            if (parent) {
                parent.classList.toggle('is-active');
            }
        }
    }

}
window.customElements.define('facet-heading', FacetHeading);

function showEverlastWipePopup(arg, func) {
    $('.everlast_wipe_popup_overlay').show();
    $('.everlast_wipe_popup_overlay .everlast_wipe_popup_button.proceed').off('click').click(() => {
        $('.everlast_wipe_popup_overlay .everlast_wipe_popup_button.proceed').html("<span class=\"loader\"></span>");
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ note: '' })
        })
            .then(res => res.json())
            .then(() => {
                fetch('/cart/clear.js', {
                    method: 'POST'
                }).then((res) => res.json()).then(() => {
                    if (arg) func(arg)
                    else func()
                })
                    .finally(() => {
                        $('.everlast_wipe_popup_overlay .everlast_wipe_popup_button.proceed').html("Proceed");
                        $('.everlast_wipe_popup_overlay').hide();
                    })
            })
    });
}

function addToCartBtnAction(event) {
    event.preventDefault();
    let pHandle = event.target.getAttribute('data-handle');
    let vId = event.target.getAttribute('data-id');
    let pType = event.target.getAttribute('data-type');
    let vOptions = event.target.getAttribute('data-options').split(' / ');
    const payload = {
        id: vId,
        quantity: 1,
        sections: [
            'cart-drawer',
            'header-classic'
        ],
    }
    if (pType == 'Prescription') {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const paramsObj = {};
        urlParams.forEach((value, key) => {
            paramsObj[key] = value;
        });

        const newUrl = `https://neveneyewear.com/products/${pHandle}?lens=rx-lens-color-${vOptions[1]}`

        const linkUrl = new URL(newUrl);
        const linkParams = new URLSearchParams(linkUrl.search);

        for (const [key, value] of urlParams.entries()) {
            if (!linkParams.has(key) && !['_ab', '_fd', '_sc', 'variant', 'development', 'qty', 'edit', 'lens', 'upgrades', 'type', 'q', 'token', 'return_url', 'page', 'oph-type', 'lens-color', 'fav-variant-id', 'tab', 'view'].includes(key)) {
                linkParams.append(key, value);
            }
        }

        linkUrl.search = linkParams.toString();

        window.location.href = linkUrl.toString();
    } else {
        event.target.innerHTML = "Adding";
        fetch('/cart/add.js', {
            body: JSON.stringify(payload),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        })
            .then(res => res.json())
            .then(res => {
                event.target.innerHTML = "Added"
                $('#shopify-section-cart-drawer .section_holder').html($(res.sections['cart-drawer']).find('.section_holder').html());
                const bubble = new DOMParser().parseFromString(res.sections['header-classic'], 'text/html').querySelector('.header-cart__count').innerHTML;
                document.querySelectorAll('.header-cart__count').forEach((element) => {
                    element.innerHTML = bubble;
                    if (+bubble > 0) {
                      $(element).show();
                    } else {
                      $(element).hide();
                    }
                });
                open_slider_cart();
            })
    }
}

const everlastTrackedFetch = (action, url, options) => {
  if (window.EverlastLogger && EverlastLogger.isEverlastPage()) {
    return EverlastLogger.trackedFetch(action, url, options || {});
  }
  return fetch(url, options);
};

const getProductCollectionHandles = (product) => {
  const nodes = product?.collections?.nodes || [];
  const primary = nodes[0]?.handle || '';
  const fallbackHandle = nodes[1]?.handle || '';
  const fallback = fallbackHandle && fallbackHandle !== primary ? fallbackHandle : '';
  return { primary, fallback };
};

const stripExchangePrefix = (name) => {
  return (name || '').trim().replace(/^exc/i, '');
};

const normalizeOrderName = (name) => {
  let normalized = stripExchangePrefix(name).trim().toLowerCase();
  if (!normalized) return '';
  if (!normalized.startsWith('#')) normalized = '#' + normalized;
  return normalized;
};

const orderNamesMatch = (orderName, inputName) => {
  if (!orderName || !inputName) return false;
  return normalizeOrderName(orderName) === normalizeOrderName(inputName);
};

const findOrderByInput = (orders, input) => {
  if (!Array.isArray(orders) || !input) return null;
  return orders.find((order) => orderNamesMatch(order.name, input)) || null;
};

const findOrderIndexByInput = (orders, input) => {
  if (!Array.isArray(orders) || !input) return -1;
  return orders.findIndex((order) => orderNamesMatch(order.name, input));
};

const getOrdersByEmailAndName = async (email, name, amazonOrderId, orderType, requestType = 'everlast') => {
  const endpoint = `https://api.neveneyewear.com/api/${requestType}/email-name`;
  const body = {
    email: email?.trim(),
    name: name?.trim(),
    source: orderType
  }
  if (orderType === 'tiktok') {
    body.tiktokOrderId = amazonOrderId?.trim();
  } else {
    body.amazonOrderId = amazonOrderId?.trim();
  }
  try {
    const res = await everlastTrackedFetch('everlast_email_name_lookup', endpoint, {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(body)
    });

    const result = await res.json();

    return result;
  } catch (err) {
    return null;
  }
}

const countLines = (selector) => { 
    var el =  
        document.querySelector(selector);
  
    if (el) {
        var divHeight = el.offsetHeight;
        var style = window.getComputedStyle(el, null);
        var fontSize = parseFloat(style.getPropertyValue('font-size')); 
        var lineHeight = parseFloat(style.getPropertyValue('line-height'));
        if (!lineHeight) {
            lineHeight = Math.floor(fontSize * 1.5);
        }
      
        var lines = divHeight / lineHeight; 
        return lines;
    } else {
        return 0;
    }
} 

const greenButtonClick = (button, event) => {
    event.preventDefault();
    event.stopPropagation();
    
    console.log(button);
    const elem = button.parentElement;
    if (elem.getAttribute('data-go-pdp') === 'true') {
        location.href = elem.getAttribute('data-go-url');
    } else {
        elem.style.pointerEvents = 'none';
        fetch('/cart/add.js', {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            id: elem.getAttribute('data-variant-id'),
            quantity: 1
        })
        })
        .then(res => res.json())
        .then(res => {
            update_cart_content()
            update_header_icon()
            open_slider_cart()
            elem.querySelector('.add').style.display = 'none'
            elem.querySelector('.added').style.display = 'block'
        })
        .finally(() => {
            elem.style.pointerEvents = 'inherit';
        })
    }
}

const onATCClicked = (button) => {
  const variantId = button.getAttribute("data-variant-id");
  button.classList.add("loading");
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(res => {
    update_cart_content();
    update_header_icon();
    open_slider_cart();
  })
  .finally(() => {
    button.classList.remove("loading");
  });
};

/**
 * Reads data from localStorage using a key
 * @param {string} key - The key to retrieve data from localStorage
 * @param {*} defaultValue - Default value to return if key doesn't exist
 * @returns {*} The stored data or default value
 */
function getLocalStorageData(key, defaultValue = null) {
  try {
    const data = localStorage.getItem(key);
    if (data === null) {
      return defaultValue;
    }
    
    // Try to parse as JSON, fallback to string if parsing fails
    try {
      return JSON.parse(data);
    } catch (parseError) {
      return data;
    }
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return defaultValue;
  }
}

/**
 * Writes data to localStorage using a key
 * @param {string} key - The key to store data under
 * @param {*} value - The data to store (will be JSON stringified if not a string)
 * @returns {boolean} True if successful, false if failed
 */
function setLocalStorageData(key, value) {
  try {
    let dataToStore;
    
    // Convert value to string for storage
    if (typeof value === 'string') {
      dataToStore = value;
    } else {
      dataToStore = JSON.stringify(value);
    }
    
    localStorage.setItem(key, dataToStore);
    return true;
  } catch (error) {
    console.error('Error writing to localStorage:', error);
    return false;
  }
}

/**
 * Observes attribute changes on elements and updates target element's innerHTML
 * @param {Object} options - Configuration object
 * @param {string} options.containerSelector - Container element selector
 * @param {string} options.observedSelector - Selector for element to observe (within container)
 * @param {string} options.targetSelector - Selector for element to update (within container)
 * @param {string} options.observedAttribute - Attribute name to observe
 * @param {string} [options.hiddenClass='hidden'] - Class name to remove when value is found
 */
function observeAttributeAndUpdate(options) {
  const {
    containerSelector,
    observedSelector,
    targetSelector,
    observedAttribute,
    hiddenClass = 'hidden'
  } = options;

  const container = document.querySelector(containerSelector);
  
  if (!container) {
    console.warn('Container not found:', containerSelector);
    return;
  }
  
  const observedContainer = container.querySelector(observedSelector);
  const targetElement = container.querySelector(targetSelector);
  
  if (!observedContainer) {
    console.warn('Observed container not found:', observedSelector);
    return;
  }
  
  if (!targetElement) {
    console.warn('Target element not found:', targetSelector);
    return;
  }
  
  // Declare observer variable before updateTarget function
  let observer;
  
  function updateTarget() {
    const element = observedContainer.querySelector(`[${observedAttribute}]`);
    if (element && element.getAttribute(observedAttribute)) {
      const value = element.getAttribute(observedAttribute);
      targetElement.innerHTML = value;
      targetElement.classList.remove(hiddenClass);
      
      // Remove observer after successful update
      if (observer) {
        observer.disconnect();
      }
    }
  }
  
  // Initial check
  updateTarget();
  
  // Set up MutationObserver
  observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === observedAttribute) {
        shouldUpdate = true;
      }
      // Also check for child nodes being added
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
      updateTarget();
    }
  });
  
  // Observe the container and its descendants
  observer.observe(observedContainer, {
    attributes: true,
    attributeFilter: [observedAttribute],
    childList: true,
    subtree: true
  });
  
  // Also observe any existing child elements
  observedContainer.querySelectorAll(`[${observedAttribute}]`).forEach(function(el) {
    observer.observe(el, {
      attributes: true,
      attributeFilter: [observedAttribute]
    });
  });
  
  return observer;
}

// Hide search box when section__menu-link is hovered for 1 second
document.addEventListener('DOMContentLoaded', () => {
  const menuLinks = document.querySelectorAll('.section__menu-link');
  let searchHideTimeout = null;

  menuLinks.forEach(menuLink => {
    menuLink.addEventListener('mouseenter', () => {
      
      // Hide search box after 1 second of hovering
      if (searchHideTimeout) {
        clearTimeout(searchHideTimeout);
      }
      searchHideTimeout = setTimeout(() => {
        // Check if search drawer is open
        if (window.searchDrawer && typeof window.searchDrawer.close === 'function') {
          window.searchDrawer.close();
        }
        // Also check for overlay search (if using overlay layout)
        const searchOverlay = document.querySelector('[data-search-type="overlay"]');
        if (searchOverlay && searchOverlay.classList.contains('is-opened')) {
          if (window.PXUTheme && window.PXUTheme.jsHeader && typeof window.PXUTheme.jsHeader.hideSearch === 'function') {
            window.PXUTheme.jsHeader.hideSearch();
          }
        }
        searchHideTimeout = null;
      }, 300);
    });

    menuLink.addEventListener('mouseleave', () => {
      // Clear timeout if mouse leaves before 1 second
      if (searchHideTimeout) {
        clearTimeout(searchHideTimeout);
        searchHideTimeout = null;
      } else {
      }
    });
  });

});

// Run the inline section scripts that were waiting for jQuery, Swiper and this file
// (see snippets/custom-js-head.liquid). Top level, so they run before vendors.js, app.js
// and the other deferred scripts, as they did when they ran inline while the page parsed.
if (window.nvnLibsLoaded) window.nvnLibsLoaded();
